export default {
  methods: {
    async initGallery (element, index, gallery) {
      this.$matomo && this.$matomo.trackEvent('Gallery', `Open ${index} ${this.diagram.name}`)
      let images = [this.diagram.image]
      let page = 1
      while (true) {
        const {
          results: slides,
          next
        } = await this.$serverBackend.get(`/diagrams/${this.diagram.id}/images/`, { page })
        images = images.concat(slides)
        page++
        if (!next) {
          break
        }
      }

      lightGallery(element, {
        index,
        speed: 500,
        infinite: true,
        slidesToSHow: 1,
        slidesToScroll: 1,
        dynamic: true,
        dynamicEl: images.map((slide) => {
          return {
            src: slide.full_size.png,
            thumb: slide.thumbnail.png,
            subHtml: slide.title,
            download: slide.full_size.png,
            downloadUrl: false
          }
        })
      })
      if (gallery) {
        gallery.index = index
        setTimeout(() => gallery.slide(index), 500)
      }
    },
    async openGallery (index) {
      const element = document.getElementById('lightgallery')
      if (element) {
        const galleryUid = element.getAttribute('lg-uid')
        const gallery = window.lgData[galleryUid]
        await this.initGallery(element, index, gallery)
      } else {
        this.$sentry.captureException(new Error('ligthgallery not found. Cannot scroll to slide'))
      }
    }
  }
}
